import { useTranslation } from 'react-i18next';
import { LocaleLink } from '@/components/LocaleLink';

// The registered address and VAT number stay on the Terms / Privacy /
// Disclaimer pages only — they are not repeated on every page.
const SUPPORT_EMAIL = 'support@ismscalculator.com';

// Presentation shared with the approved homepage. Event-bearing links are
// injected by that page only; other routes must never emit landing events.
export const PublicFooter = ({ links, testPrefix = 'public-footer' }) => {
  const { t } = useTranslation();
  return <footer className="lp-footer" data-testid={testPrefix}>
    <div className="lp-container site-container">
      <div className="lp-footer-top">
        <div><LocaleLink to="/" className="lp-brand" data-testid={`${testPrefix}-brand`}>ISMSCalculator</LocaleLink>
          <p data-testid={`${testPrefix}-positioning`}>{t('homepage.positioning')}</p></div>
        <nav aria-label={t('homepage.footerNavigation')} data-testid={`${testPrefix}-navigation`}>
          {links || <>
            <LocaleLink to="/calculator" data-testid={`${testPrefix}-calculator`}>{t('homepage.primaryAction')}</LocaleLink>
            <LocaleLink to="/methodology" data-testid={`${testPrefix}-methodology`}>{t('homepage.methodologyLink')}</LocaleLink>
            <LocaleLink to="/blog" data-testid={`${testPrefix}-blog`}>{t('footer.blog')}</LocaleLink>
            <LocaleLink to="/auth" data-testid={`${testPrefix}-signin`}>{t('nav.signIn')}</LocaleLink>
          </>}
        </nav>
      </div>
      <div className="lp-footer-bottom">
        <div><p data-testid={`${testPrefix}-copyright`}>© {new Date().getFullYear()} ISMSCalculator</p>
          <p data-testid={`${testPrefix}-legal-entity`}>{t('footer.legalEntity')} ·{' '}
            <a href={`mailto:${SUPPORT_EMAIL}`} data-testid={`${testPrefix}-support-email`}>{SUPPORT_EMAIL}</a>
          </p></div>
        <nav aria-label={t('footer.legal')} data-testid={`${testPrefix}-legal-navigation`}>
          {['privacy', 'terms', 'disclaimer'].map(key => <LocaleLink key={key} to={`/${key}`} data-testid={`${testPrefix}-${key}`}>{t(`footer.${key}`)}</LocaleLink>)}
        </nav>
      </div>
    </div>
  </footer>;
};